const state = {
	env: "dev",
	apiHost: {
		dev: "https://ad.yuzhileyouke.cn/api",
		uat: "https://ad.yuzhileyouke.cn/api",
		pro: "https://ad.yuzhileyouke.cn/api",
	},
};
const mutations = {
	setEnv(state, payload) {
		state.env = payload.env;
	},
};
export default {
	namespaced: true, // 开启namespace:true，该模块就成为命名空间模块了
	state,
	mutations,
};